(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gr-nexx-styles"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gr-nexx-styles')) {
  class NexxStylesCarousel extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.viewport = this.querySelector('[data-viewport]');
      this.group = this.querySelector('[data-group]');
      this.track = this.querySelector('[data-track]');
      this.pauseButton = this.querySelector('[data-action="pause"]');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.reducedMotion.matches;
      this.inView = false;
      this.hovered = false;
      this.focused = false;
      this.cooldown = false;
      this.position = 0;
      this.speed = Number(this.dataset.speed) || 20;
      const signal = this.abort.signal;
      const clone = this.group.cloneNode(true);
      clone.dataset.clone = '';
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[data-shopify-editor-block]').forEach(item => item.removeAttribute('data-shopify-editor-block'));
      clone.querySelectorAll('a').forEach(link => link.setAttribute('tabindex', '-1'));
      this.track.prepend(clone);
      this.querySelector('[data-controls]').hidden = false;
      this.refresh = () => {
        this.groupWidth = this.group.getBoundingClientRect().width;
        if (!this.positioned && this.groupWidth) {
          this.viewport.scrollLeft = this.groupWidth;
          this.positioned = true;
        }
        this.updatePlayback();
      };
      this.onMouseEnter = () => { this.hovered = true; this.updatePlayback(); };
      this.onMouseLeave = () => { this.hovered = false; this.updatePlayback(); };
      this.addEventListener('mouseenter', this.onMouseEnter, { signal });
      this.addEventListener('mouseleave', this.onMouseLeave, { signal });
      this.addEventListener('focusin', () => { this.focused = true; this.updatePlayback(); }, { signal });
      this.addEventListener('focusout', event => {
        this.focused = this.contains(event.relatedTarget);
        this.updatePlayback();
      }, { signal });
      this.viewport.addEventListener('pointerdown', () => this.rest(), { signal, passive: true });
      this.viewport.addEventListener('wheel', () => this.rest(), { signal, passive: true });
      this.viewport.addEventListener('keydown', () => this.rest(), { signal });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-action], [data-direction]');
        if (!button) return;
        const action = button.dataset.action || (button.dataset.direction === '-1' ? 'previous' : 'next');
        if (action === 'pause') {
          this.paused = !this.paused;
          this.updateButton();
          this.updatePlayback();
          return;
        }
        this.rest();
        const distance = Math.max(128, this.viewport.clientWidth * 0.7);
        if (action === 'previous' && this.viewport.scrollLeft < 1) this.viewport.scrollLeft = this.groupWidth;
        this.viewport.scrollBy({ left: action === 'previous' ? -distance : distance, behavior: this.reducedMotion.matches ? 'instant' : 'smooth' });
      }, { signal });
      document.addEventListener('visibilitychange', () => this.updatePlayback(), { signal });
      this.motionChanged = () => {
        this.paused = this.reducedMotion.matches || this.dataset.autoplay !== 'true';
        this.updateButton();
        this.updatePlayback();
      };
      this.reducedMotion.addEventListener('change', this.motionChanged);
      this.intersection = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.updatePlayback();
      });
      this.intersection.observe(this);
      this.resize = new ResizeObserver(this.refresh);
      this.resize.observe(this.viewport);
      this.resize.observe(this.group);
      this.updateButton();
      this.refresh();
    }

    updateButton() {
      const label = this.paused ? this.pauseButton.dataset.labelPlay : this.pauseButton.dataset.labelPause;
      this.pauseButton.setAttribute('aria-label', label);
      this.pauseButton.setAttribute('title', label);
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
      this.pauseButton.querySelector('[data-icon="pause"]').hidden = this.paused;
      this.pauseButton.querySelector('[data-icon="play"]').hidden = !this.paused;
    }

    rest() {
      this.cooldown = true;
      clearTimeout(this.restTimer);
      this.updatePlayback();
      this.restTimer = setTimeout(() => {
        this.cooldown = false;
        this.updatePlayback();
      }, 10000);
    }

    updatePlayback() {
      cancelAnimationFrame(this.frame);
      if (this.paused || this.hovered || this.focused || this.cooldown || !this.inView || document.hidden || !this.groupWidth || this.groupWidth <= this.viewport.clientWidth) return;
      this.position = this.viewport.scrollLeft;
      this.previousTime = 0;
      const tick = time => {
        if (this.previousTime) {
          this.position -= Math.min(time - this.previousTime, 64) / 1000 * this.speed;
          this.position = ((this.position % this.groupWidth) + this.groupWidth) % this.groupWidth;
          this.viewport.scrollLeft = this.position;
        }
        this.previousTime = time;
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      cancelAnimationFrame(this.frame);
      clearTimeout(this.restTimer);
      this.resize?.disconnect();
      this.intersection?.disconnect();
      this.reducedMotion?.removeEventListener('change', this.motionChanged);
      this.querySelector('[data-clone]')?.remove();
      this.positioned = false;
    }
  }
  customElements.define('gr-nexx-styles', NexxStylesCarousel);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
